import AppAlertComponent from '@/app/common/components/AppAlertComponent/AppAlertComponent'
import { UserQueries } from '@/queries/users/queries'
import {
  RefreshFamilyApplication,
  selectFamilyApplication,
} from '@/storage/applications/familyApplicationSlice'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Chat } from './_components/Chat'
import { useEffect, useRef } from 'react'
import { LogUserActivity } from '@/apis/users/requests.ts'
import { LOG_TYPES } from '@/app/pages/family_application/constants.ts'
import { selectProgramID } from '@/storage/program_settings/programSettingsSlice'
import { AppDispatch } from '@/storage/store'
import { useGetPayments } from '@/apis/payments/hooks/useGetPayments'
import PageLoader from '@/app/common/components/PageLoader/PageLoader'

function MessagesPage() {
  const application = useSelector(selectFamilyApplication)
  const request = useQuery(
    UserQueries.getAuthenticatedUser(application.applicant_id)
  )
  const dispatch = useDispatch<AppDispatch>()
  const programId = useSelector(selectProgramID)
  const { t } = useTranslation()
  const paymentQuery = useGetPayments({
    applicant_id: application.applicant_id,
    page: 0,
    per_page: 50,
    program_id: programId,
    search: '',
  })

  useEffect(() => {
    dispatch(RefreshFamilyApplication(programId))
  }, [])

  const hasLoggedPageView = useRef(false)
  useEffect(() => {
    if (!hasLoggedPageView.current) {
      LogUserActivity({
        log_type: LOG_TYPES.VIEW_PAGE,
        suffix_text: 'Viewed Messages page',
      })
      hasLoggedPageView.current = true
    }
  }, [])

  if (!request.data) {
    return null
  }

  return(
    <PageLoader query={paymentQuery}
    >
      {(payments) => {
          const paymentsWithMessages = payments?.data ? payments.data?.filter((payment) => payment.messages.length > 0) : []

          if (paymentsWithMessages.length == 0 && application.flags.length === 0) {
            return (
              <div className="flex items-center justify-center h-full max-w-md mx-auto">
                <AppAlertComponent
                  className="flex"
                  children={null}
                  title={t('you_have_no_messave_title')}
                  text={t('you_have_no_messave_body')}
                  variant="info"
                  needHelp
                ></AppAlertComponent>
              </div>
            )
          }

          return (
            <main className="h-full lg:max-h-screen  ">
              <Chat user={request.data} application={application} payments={paymentsWithMessages} />
            </main>
          )
      }}
    </PageLoader>
  )
}

export default MessagesPage
